export const LIST_SESSIONSTORAGE_POSITION_KEY = 'pro-list-position';

export const LIST_SESSIONSTORAGE_STATE_KEY = 'pro-list-state';
